import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    title: 'Cuaderno Maestro de Medición en Obra',
    desc: 'Protocolo de 7 pasos + plantillas por tipología. Cero medidas incompletas.',
    value: '$5.000'
  }, {
    title: 'Checklist Total de Entrega y Postventa',
    desc: '30 puntos de control, acta firmada y guía para el cliente. Cero reclamos.',
    value: '$5.000'
  }, {
    title: 'Manual Express Para Defender Tu Precio',
    desc: 'Respuestas a objeciones, guión de presupuesto y 3 mensajes de cierre.',
    value: '$5.000'
  }, {
    title: 'Atlas Visual de Aberturas de Aluminio',
    desc: '18 planos imprimibles con vista frontal, sección y componentes numerados.',
    value: '$5.000'
  }];
  return <section className="py-12 relative" data-id="element-17">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-18">
        <FadeIn data-id="element-19">
          <div className="text-center mb-10" data-id="element-20">
            <h2 className="text-4xl md:text-6xl font-bold mb-4 text-white" data-id="element-21">
              🎁 4 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-gold text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-22">
              SIEMPRE INCLUIDOS
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-23">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-24">
              <div className="bg-surface p-6 rounded-2xl border border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:border-yellow/30 transition-colors" data-id="element-25">
                <div className="flex items-start gap-4" data-id="element-26">
                  <span className="text-2xl font-bold text-gold opacity-50" data-id="element-27">
                    0{i + 1}
                  </span>
                  <div data-id="element-28">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-29">
                      🎁 BONO {i + 1} — {bono.title}
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-30">{bono.desc}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 md:flex-col md:items-end md:gap-1 shrink-0" data-id="element-31">
                  <span className="text-gray-500 line-through text-sm" data-id="element-32">
                    Valor: {bono.value}
                  </span>
                  <span className="bg-yellow text-background font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wide" data-id="element-33">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-34">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-r from-surface to-surfaceLight border border-yellow/20" data-id="element-35">
            <p className="text-xl md:text-2xl font-medium" data-id="element-36">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-37">$20.000</span>{' '}
              <span className="text-yellow font-bold" data-id="element-38">
                → GRATIS con tu Sistema Maestro
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}